module.exports = __webpack_public_path__ + "img/thumb-009-23.11a2219c.png";